var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.334,
    height: 121.027,
    viewBox: "0 0 117.334 121.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.916 -0.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.633,17.975a2.851,2.851,0,1,0-3.577-1.831A2.855,2.855,0,0,0,5.633,17.975Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.829,8.669A1.939,1.939,0,1,0,9.4,7.424,1.941,1.941,0,0,0,11.829,8.669Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.878,18.459a4.351,4.351,0,0,0,.275-6.125,4.3,4.3,0,0,0-6.1-.276,4.35,4.35,0,0,0-.274,6.125A4.3,4.3,0,0,0,104.878,18.459Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.659,10.555a1.832,1.832,0,0,0,.116-2.579,1.811,1.811,0,0,0-2.567-.116,1.832,1.832,0,0,0-.115,2.579A1.81,1.81,0,0,0,118.659,10.555Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.62,111.9a1.832,1.832,0,0,0,.115-2.579,1.811,1.811,0,0,0-2.566-.116,1.832,1.832,0,0,0-.116,2.579A1.811,1.811,0,0,0,10.62,111.9Z",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.685,54.041l-7.38-31.489A4.352,4.352,0,0,1,17.485,17.3L66.192,5.667,93.781,24.492l17.258,69.252a4.353,4.353,0,0,1-3.179,5.248L40.646,114.964a4.329,4.329,0,0,1-5.223-3.195L21.118,51.645",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724,51.872l-26,66.4a4.3,4.3,0,0,1-5.677,2.4L11.126,94.427a4.33,4.33,0,0,1-2.384-5.7l34.4-84.882a4.3,4.3,0,0,1,5.677-2.4L95.257,20.5Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.025,105.5a4.323,4.323,0,0,1-4.314,4.335H26.681a4.323,4.323,0,0,1-4.314-4.335V13.767a4.323,4.323,0,0,1,4.314-4.335H76.75L99.23,34.189l.454,41.528Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.685,54.041l-7.38-31.489A4.352,4.352,0,0,1,17.485,17.3L66.192,5.667,93.781,24.492l17.258,69.252a4.353,4.353,0,0,1-3.179,5.248L40.646,114.964a4.329,4.329,0,0,1-5.223-3.195L21.118,51.645",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724,51.872l-26,66.4a4.3,4.3,0,0,1-5.677,2.4L11.126,94.427a4.33,4.33,0,0,1-2.384-5.7l34.4-84.882a4.3,4.3,0,0,1,5.677-2.4L95.257,20.5Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.645,26.773,87.763,38.639A5.241,5.241,0,0,0,90.6,45.256l16.122,6.617",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.025,105.5a4.323,4.323,0,0,1-4.314,4.335H26.681a4.323,4.323,0,0,1-4.314-4.335V13.767a4.323,4.323,0,0,1,4.314-4.335H76.75L99.23,34.189l.454,41.528Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.309,83.59H45.868a1.255,1.255,0,0,1,0-2.51H87.309a1.263,1.263,0,0,1,1.249,1.255A1.345,1.345,0,0,1,87.309,83.59Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.759,83.59H33.493a1.255,1.255,0,0,1,0-2.51h7.266a1.255,1.255,0,0,1,0,2.51Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,72.295H68.689a1.255,1.255,0,0,1,0-2.51H87.2a1.263,1.263,0,0,1,1.249,1.255C88.331,71.838,87.877,72.295,87.2,72.295Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.855,72.295H33.833a1.255,1.255,0,0,1,0-2.51H60.855A1.263,1.263,0,0,1,62.1,71.04,1.194,1.194,0,0,1,60.855,72.295Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.536,61.114H80.384a1.255,1.255,0,0,1,0-2.51h7.153a1.255,1.255,0,0,1,0,2.51Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.686,61.114H34.175a1.255,1.255,0,0,1,0-2.51H73.686a1.255,1.255,0,0,1,0,2.51Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.974,95.911h-2.5a1.255,1.255,0,0,1,0-2.51h2.5a1.263,1.263,0,0,1,1.249,1.255A1.444,1.444,0,0,1,55.974,95.911Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.934,95.911H34.175a1.255,1.255,0,0,1,0-2.51H48.821a1.263,1.263,0,0,1,1.249,1.255A1.107,1.107,0,0,1,48.934,95.911Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.877,49.933H62.445a1.255,1.255,0,0,1,0-2.51H87.877a1.255,1.255,0,0,1,0,2.51Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.27,49.933H34.515a1.255,1.255,0,0,1,0-2.51H54.157a1.263,1.263,0,0,1,1.249,1.255A1.17,1.17,0,0,1,54.27,49.933Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.122,24.606H34.969a1.6,1.6,0,0,1,0-3.194H68.122a1.556,1.556,0,0,1,1.59,1.6A1.713,1.713,0,0,1,68.122,24.606Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.572,32.592h-12.6a1.6,1.6,0,0,1,0-3.194H47.686a1.556,1.556,0,0,1,1.59,1.6A1.824,1.824,0,0,1,47.572,32.592Z",
    fill: "#c7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.751,9.432V29.055a5.151,5.151,0,0,0,5.109,5.02H99.231",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.751,19.586v9.469a5.151,5.151,0,0,0,5.109,5.02H99.231",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.027,55.752l-.908-4.107",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.589,112l-13.057,3.08a4.266,4.266,0,0,1-4.769-2.168",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.345,47.081,107.5,79.591",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.764,6.694l4.428-1.027,5.45,3.651",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.685,54.041l-7.38-31.488A4.352,4.352,0,0,1,17.485,17.3",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.306,95.8l-3.179-1.369a4.33,4.33,0,0,1-2.384-5.7L22.367,55.067",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.017,109.83l-3.293,8.442a4.3,4.3,0,0,1-5.677,2.4L48.593,109.83",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.86,14.908l13.284,5.476,11.58,31.488-3.746,9.584",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.873,9.318l2.271-5.59a4.3,4.3,0,0,1,5.677-2.4L67.668,9.09",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.873,9.318H76.75L99.23,34.075,99.685,75.6l.34,29.892a4.323,4.323,0,0,1-4.314,4.335H26.681a4.323,4.323,0,0,1-4.314-4.335V13.767a4.323,4.323,0,0,1,4.314-4.335H29.86",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.467,74.12h.227",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.e3405afa05f29578b4152e90efcb502a.svg";
export { ForwardRef as ReactComponent };